// True while react-snap is prerendering, or when the page arrived as prerendered HTML.
// Above-the-fold entrance animations are skipped in both cases, so the headline is
// visible in the static HTML and on first paint (better LCP; no hidden-then-revealed
// hero). Animations still run for scroll reveals and below-the-fold content.
export const skipIntro = () =>
    typeof window !== "undefined" &&
    (navigator.userAgent === "ReactSnap" || window.__EL_PRERENDERED === true);
